<template>
		<div class="right_hot_news_ctn right">
      <h3 class="title_h3"><img class="img" :src="publicPath + imgSrc + '?time=' + new Date().getTime()" /></h3>
      <!-- 81主站显示 -->
      <ul class="hot_news_list_ul" v-if="platformInfo.appId == '74web89ynsg'">
        <li v-for="(item, index) in List.slice(0, 5)" :key="index">
          <h5 class="nowrap_class" @click="goNewDetail(item.snowflakeId)">
            <span class="colorgreen">{{index +1}}.</span>
            <span>{{item.title}}</span>
          </h5>
          <p class="txt_p">{{item.summary}}</p>
        </li>
      </ul>
      <!-- 其他页面 -->
      <ul class="hot_news_list_ul" v-else>
          <li  v-for="(item, index) in List" :key="index">
              <h5 class="nowrap_class" @click="goDetail(item.snowflakeId)">
                  <span class="colorgreen">{{index +1}}.</span>
                  <span>{{ item.title }}</span>
              </h5>
          </li>
      </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	components: {

	},
  computed: {
    ...mapState(['platformInfo', 'publicPath']),
    tjstyle() {
      return this.platformInfo.appId === '2DW29x025k8'
    }
  },
	props: {
		List: { // 右侧列表
			type: Array,
			default() {}

		},
    imgSrc:{
      ype: String,
      default() {}

    }

	},
 	data() {
		return {

		};
	},
	mounted(){

	},
	methods: {

		goDetail(e) {
			this.$emit('goDetail', e);
		},
    goNewDetail(e) {
      console.log(e)
    	this.$emit('goNewDetail', e);
    }
	}
};
</script>

<style scoped>
@import "../assets/style/new.css";
.title_h3 img{
  width: 103px !important;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/list-right.vue